import { useState } from "react";

import { Button } from "@mui/material";

type CopilotSectionProps = {
  onOpenCopilot: (prompt: string) => void;
};

export const CopilotSection: React.FC<CopilotSectionProps> = ({
  onOpenCopilot,
}) => {
  const [prompt, setPrompt] = useState("");

  const handleAskCopilot = () => {
    const trimmedPrompt = prompt.trim();
    onOpenCopilot(trimmedPrompt);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAskCopilot();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 pb-2" data-loc="copilot-section">
      <h3 className="font-inter-semibold-13px text-gray-800">
        What would you like to calculate?
      </h3>
      <div className="flex h-8 w-full items-center overflow-hidden rounded-lg border border-gray-200 bg-white focus-within:border-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600/25">
        <input
          className="flex-1 bg-white px-3 py-1 font-inter-normal-12px placeholder:text-gray-500 focus:outline-none"
          data-loc="copilot-prompt-input"
          placeholder="e.g. Total transaction amount in the last 30 days by card"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button
          className="!bg-gray-100 h-full w-24 rounded-r-lg border-gray-200 border-l text-gray-500 transition-colors"
          data-loc="ask-copilot-button"
          onClick={handleAskCopilot}
        >
          <span className="font-inter-medium-12px text-gray-500 capitalize">
            Ask Copilot
          </span>
        </Button>
      </div>
    </div>
  );
};
